import palette from '../palette';

const MuiSwitch = {
  styleOverrides: {
    root: {
      '& .MuiSwitch-switchBase': {
        '&.Mui-checked': {
          '& + .MuiSwitch-track': {
            backgroundColor: palette._next.primary.main,
            opacity: 0.5,
          },
          '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.3,
          },
          '&:hover': {
            backgroundColor: palette._next.primary._states.hover,
          },
          color: palette._next.primary.main,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.3,
        },
        '&:hover': {
          backgroundColor: palette._next.action.hover,
        },
      },
    },
    thumb: {
      boxShadow:
        '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    },
  },
};

export default MuiSwitch;
